export default {
  component: () => import('./page.vue'),
  path: '/family',
  name: 'families',
  meta: {
    title: '我的家庭组',
    auth: true,
  },
};
